module.exports = __webpack_public_path__ + "img/icon_onboarding_idcard.61e34573.svg";